import { Navigate, useSearchParams } from 'react-router';
import { isNotEmpty } from '~/utils/helpers';

interface Props {
  path: string;
}

const RedirectWithQueryParams: React.FC<Props> = ({ path }) => {
  const [params] = useSearchParams();
  const queryString = params.toString();
  const to = isNotEmpty(queryString) ? `${path}?${queryString}` : path;
  return <Navigate to={to} replace />;
};

export default RedirectWithQueryParams;
